<template>
    <div>
        <!--调拨详情-->
        <Card :bordered="false" dis-hover>
            <p slot="title">详情</p>
            <Row>
                <Col span="8"><strong>结算类型：</strong><span class="result">{{pageData.tradetypename}}</span></Col>
                <Col span="8"><strong>结算账户：</strong> <span class="result">￥{{pageData.bankname}}</span></Col>
                <Col span="8"><strong>结算金额：</strong> <span class="result">{{pageData.money }}</span></Col>
                <Col span="8"><strong>结算时间：</strong> <span class="result">{{pageData.time }}</span></Col>
                <Col span="8"><strong>开具人：</strong> <span class="result">{{pageData.username }}</span></Col>
                <Col span="24"><strong>备注：</strong> <span class="result">{{pageData.remark }}</span></Col>
                <Col span="24"><strong>图片：</strong></Col>
            </Row>
            <div v-for="(k,v) in imglist">
                <img :src="k| filtImg(k)" style="width: 30%;margin: 20px 0;">
            </div>
        </Card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pageData:{},
                imglist:[],
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getAccounts(this.$route.query.id)
        },

        methods: {
            //获取采购单
            getAccounts(id){
                this.$Api.getAccounts({
                    id:id
                }).then(res => {
                    if(res.code==200){
                         this.pageData = res.data
                         this.imglist = res.data.img.split(',')
                         this.pageData.username = JSON.parse(localStorage.getItem('adminUser')).name
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        display: inline-block;
        margin-bottom: 15px;
    }
    .ive-table{
        margin-top: 20px;
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 10px;
        }
    }
</style>